/* eslint-disable max-lines */
/* eslint-disable camelcase */ // TODO: to be removed in a separate PR post nextjs upgrade is complete
/* eslint-disable extra-rules/no-commented-out-code */
// 9fbef606107a605d69c0edbcd8029e5d
import { toggleApplyNowModal } from '@tcp/core/src/components/common/molecules/ApplyNowPLCCModal/container/ApplyNowModal.actions';
import { setLoaderState } from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  setPlccEligible,
  setPlccPrescreenCode,
} from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCard.actions';
import { getSavedContactDetails } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { getRtpsPreScreenData } from '@tcp/core/src/components/features/browse/ApplyCardPage/container/ApplyCard.selectors';
import BAG_PAGE_ACTIONS, {
  isPlccIsShippingAddressModalOpen,
} from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.actions';
import {
  clearEddTTL,
  resetEddData,
} from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.actions';
import GIFT_SERVICES_CONSTANTS from '@tcp/core/src/components/features/CnC/Checkout/organisms/ShippingPage/molecules/GiftServices/GiftServices.constants';
import { call, put, select } from 'redux-saga/effects';
import { setLocalStorage, getLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import { getRtpsModalThreshold } from '../../../../../reduxStore/selectors/session.selectors';
import addUpdateAddress from '../../../../../services/abstractors/SFCC/account/AddEditAddress';
import {
  acceptOrDeclinePreScreenOffer,
  addPickupPerson,
  getServerErrorMessage,
  saveOrUpdateBillingInfo,
  updateRTPSData,
  addGiftWrappingOption,
  removeGiftWrappingOption,
} from '../../../../../services/abstractors/CnC/Checkout';
import {
  setShippingMethodAndAddressId,
  updateShippingAddressMethodAndGiftOption,
} from '../../../../../services/abstractors/CnC/CheckoutSFCC';
import { getVenmoToken } from '../../../../../services/abstractors/CnC/venmo';
import { getAppleToken } from '../../../../../services/abstractors/CnC/apple';
import { getSessionStorage } from '../../../../../utils';
import logger from '../../../../../utils/loggerInstance';
import {
  addAddressGet,
  updateAddressPut,
} from '../../../../common/organisms/AddEditAddress/container/AddEditAddress.saga';
import { getAddressList } from '../../../account/AddressBook/container/AddressBook.saga';
import { getAddressListState } from '../../../account/AddressBook/container/AddressBook.selectors';
import { getCardList } from '../../../account/Payment/container/Payment.saga';
import { setIsExpressEligible } from '../../../account/User/container/User.actions';
import { getUserEmail } from '../../../account/User/container/User.selectors';
import { processMutationNonCachedDataSaga } from '../../BagPage/container/BagPage.saga';
import BagPageSelectors from '../../BagPage/container/BagPage.selectors';
import { getGrandTotal } from '../../common/organism/OrderLedger/container/orderLedger.selector';
import constants, { CHECKOUT_ROUTES } from '../Checkout.constants';
import utility from '../util/utility';
import CHECKOUT_ACTIONS, {
  fetchDefaultShipmentMethods,
  getAppleClientTokenSuccess,
  getSetShippingValuesActn,
  getVenmoClientTokenError,
  getVenmoClientTokenSuccess,
  setGiftWrap,
  setIsRedirectFromExpress,
  setOnFileAddressKey,
  setSmsNumberForUpdates,
  submitVerifiedAddressData,
  toggleCheckoutRouting,
  appleLoaderState,
  setIsUpdatingShipmentMethods,
} from './Checkout.action';
import selectors, {
  isExpressCheckout,
  isGuest,
  isSfsInvMessagingEnabled,
} from './Checkout.selector';
import { getIsPrescreenFromBrowse } from '../../../../common/molecules/GlobalRtpsModal/container/GlobalRtpsModal.selector';
import { getRouteToCheckoutStage } from './CheckoutCommon.saga';
import ApplyCardDynamicStore from '../../../browse/ApplyCardPage/container/ApplyCardDynamicStore';

export function* addRegisteredUserAddress({
  address,
  phoneNumber,
  emailAddress,
  setAsDefault,
  saveToAccount,
}) {
  let addOrEditAddressResponse = null;
  const isGuestUser = yield select(isGuest);
  const selectedAddressId = yield select(selectors.getOnFileAddressKey);
  const userAddresses = yield select(getAddressListState);
  const selectedAddress =
    userAddresses && userAddresses.find((item) => item.addressId === selectedAddressId);
  if (selectedAddress) {
    addOrEditAddressResponse = { payload: { addressId: selectedAddressId } };
  } else {
    // const oldShippingDestination = yield select(getShippingDestinationValues);
    // let oldSelectedAddressBookEntry = yield select(
    //   getAddressByKey(store.getState(), oldShippingDestination.onFileAddressKey)
    // );
    // onFileAddressKey = !oldSelectedAddressBookEntry
    //   ? oldShippingDestination.onFileAddressKey
    //   : null;
    addOrEditAddressResponse = yield call(
      addAddressGet,
      {
        payload: {
          ...address,
          address1: address.addressLine1,
          address2: address.addressLine2 ? address.addressLine2 : '',
          zip: address.zipCode,
          phoneNumber,
          emailAddress,
          primary: `${setAsDefault}`,
          phone1Publish: `${saveToAccount}`,
          fromPage: '',
        },
      },
      false // add to address book inside redux-store
    );
    addOrEditAddressResponse = { payload: { addressId: addOrEditAddressResponse.body.addressId } };
    if (!isGuestUser) {
      yield call(getAddressList);
    }
  }
  return addOrEditAddressResponse;
  // }
}

// SFCC-TODO : Need to check usages for this function
// eslint-disable-next-line no-unused-vars
const setAddressId = (addressId, payload, currentStage) => {
  return (
    !addressId &&
    (currentStage === constants.CHECKOUT_STAGES.REVIEW ||
      (currentStage === constants.CHECKOUT_STAGES.SHIPPING && payload && payload.isAddressChange))
  );
};

function* updateShipmentMethodSelectionErrorHandling(err) {
  const errorsMapping = yield select(BagPageSelectors.getErrorMapping);
  const billingError = getServerErrorMessage(err, errorsMapping);
  let setServerErrorPayload = { errorMessage: billingError, component: 'PAGE' };
  if (isSfsInvMessagingEnabled && billingError.errorMessage) {
    setServerErrorPayload.errorMessage = '';
    setServerErrorPayload = { ...setServerErrorPayload, billingError };
  }
  yield put(CHECKOUT_ACTIONS.setServerErrorCheckout(setServerErrorPayload));
}

// NOTE: Removed for SFCCC-5223
// eslint-disable-next-line no-unused-vars
function* submitBillingForPlcc(onFileAddressKey, onFileAddressId, navigation) {
  const billingValues = yield select(selectors.getBillingValues);
  const { billing, address = {} } = billingValues || {};
  if (
    billing &&
    billing.cardType === 'PLACE CARD' &&
    address.onFileAddressId === onFileAddressKey
  ) {
    const grandTotal = yield select(getGrandTotal);
    const piAmount = grandTotal && grandTotal.toString();
    const isGuestUser = yield select(isGuest);
    const errorMappings = yield select(BagPageSelectors.getErrorMapping);
    const requestData = {
      addressId: onFileAddressId,
      fromPage: 'checkout',
      paymentInstruction: [
        {
          billing_address_id: onFileAddressId.toString(),
          piAmount,
          creditCardId: billingValues.onFileCardId.toString(),
          cc_brand: 'PLACE CARD',
          payMethodId: 'ADSPlaceCard',
          cc_cvc: '',
          account: billing.cardNumber,
          expire_month: billing.expMonth.toString() || '',
          expire_year: billing.expYear.toString() || '',
          saveToAccount: !isGuestUser,
          applyToOrder: true,
          recaptchaToken: '',
        },
      ],
    };

    const header = {
      saveToAccount: !isGuestUser,
      nickName: address.onFileAddressKey,
    };
    yield call(saveOrUpdateBillingInfo, { requestData, header, navigation }, errorMappings);
  }
}

export function* updateShipmentMethodSelection({ payload }) {
  // const currentStage = yield select(selectors.getCurrentCheckoutStage);
  // SFCC-TODO: Need to check addressId logic
  // let addressId = yield select(selectors.getOnFileAddressKey);
  // if (setAddressId(addressId, payload, currentStage.toLowerCase())) {
  //   addressId = yield select(selectors.getShippingAddressID);
  // }
  const address = yield select(selectors.getShippingAddress);
  if (address) {
    yield put(setLoaderState(true));
    try {
      // let calcValue = true;
      // const isOptimseUpdateShipment = yield select(selectors.getIsOptimseUpdateShipment);
      // if (isOptimseUpdateShipment) {
      //   calcValue = constants.CALC_VALUE;
      // }
      let respToProcess = null;
      try {
        const { shippingMethodResp = {} } = yield call(setShippingMethodAndAddressId, payload.id);
        respToProcess = shippingMethodResp;
      } catch (err) {
        if (
          err.errorCodes &&
          err.errorCodes.indexOf(constants.ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION) > -1
        ) {
          throw err;
        }
      }
      // NOTE: Removed for SFCCC-5223
      // yield call(submitBillingForPlcc, onFileAddressKey, onFileAddressId, navigation);
      if (!payload.isAddressChange) {
        yield call(processMutationNonCachedDataSaga, {
          payload: {
            respToProcess,
          },
        });
      }
      yield put(CHECKOUT_ACTIONS.setServerErrorCheckout({}));
      yield put(setLoaderState(false));
    } catch (err) {
      yield put(setLoaderState(false));
      yield call(updateShipmentMethodSelectionErrorHandling, err);
    }
  }
}

function* setShipmentValues(shouldUpdateCart, response, navigation) {
  if (shouldUpdateCart) {
    const { onFileAddressKey, onFileAddressId } = response;
    const shipModeId = yield select(BagPageSelectors.getShippingModeID);
    yield call(updateShipmentMethodSelection, {
      payload: { id: shipModeId },
      onFileAddressKey,
      onFileAddressId,
      navigation,
    });
  } else {
    yield put(getSetShippingValuesActn(response));
  }
}

export function* updateShippingAddress({ payload, after }) {
  const { shippingAddress = {}, submitData = () => {}, navigation } = payload;
  yield put(clearEddTTL());
  const isGuestUser = yield select(isGuest);
  const {
    shipTo: { address, setAsDefault, phoneNumber, saveToAccount, onFileAddressKey },
    shouldUpdateCart,
  } = payload;
  let {
    shipTo: { emailAddress },
  } = payload;
  if (!emailAddress) {
    // on registered user entering a new address the email field is not visible -> emailAddress = null
    emailAddress = yield select(getUserEmail);
  }
  const userAddresses = yield select(getAddressListState);
  const selectedAddress =
    userAddresses && userAddresses.find((item) => item.addressId === onFileAddressKey);
  const selectedShippingAddress = yield select(selectors.getShippingAddress);
  const { nickName: shippingAddressNickName = '' } = selectedShippingAddress || {};

  const updateAddressResponse = yield call(
    updateAddressPut,
    {
      payload: {
        ...address,
        address1: address.addressLine1,
        address2: address.addressLine2 ? address.addressLine2 : '',
        zip: address.zipCode,
        phoneNumber,
        email: emailAddress,
        primary: setAsDefault ? `${setAsDefault}` : undefined,
        phone1Publish: saveToAccount,
        xcont_pageName: 'myAccount',
        nickName:
          selectedAddress && selectedAddress.nickName
            ? selectedAddress.nickName
            : shippingAddressNickName,
      },
    },
    true
  );
  if (!isGuestUser) {
    yield call(getAddressList);
    yield call(getCardList, { ignoreCache: true });
  }

  if (after) {
    after();
  }
  yield put(resetEddData());
  yield put(setOnFileAddressKey(updateAddressResponse));
  const { addressId = '' } = updateAddressResponse;
  const response = {
    phoneNumber,
    onFileAddressKey,
    emailAddress,
    address: { ...address, addressId },
    onFileAddressId: addressId,
    ...selectedShippingAddress,
  };
  yield setShipmentValues(shouldUpdateCart, response, navigation);

  yield put(
    submitVerifiedAddressData({
      shippingAddress,
      submitData,
      navigation,
    })
  );
  yield put(setIsUpdatingShipmentMethods(false));
}

export function* addNewShippingAddress({ payload }) {
  const isGuestUser = yield select(isGuest);
  const {
    shipTo: { address, setAsDefault, phoneNumber, saveToAccount },
  } = payload;
  let {
    shipTo: { emailAddress },
  } = payload;
  if (!emailAddress) {
    // on registered user entering a new address the email field is not visible -> emailAddress = null
    emailAddress = yield select(getUserEmail);
  }
  const addAddressResponse = yield call(
    addAddressGet,
    {
      payload: {
        ...address,
        address1: address.addressLine1,
        address2: address.addressLine2 ? address.addressLine2 : '',
        zip: address.zipCode,
        phoneNumber,
        emailAddress,
        primary: `${setAsDefault}`,
        phone1Publish: `${saveToAccount}`,
        fromPage: '',
      },
    },
    true
  );
  if (!isGuestUser) {
    yield call(getAddressList);
  }
  yield put(setOnFileAddressKey(addAddressResponse.payload));
}

export function* routeToPickupPage(recalc) {
  yield call(utility.routeToPage, CHECKOUT_ROUTES.pickupPage, { recalc });
}

export function createGitOptionRequestDTO(payload, hasSetGiftOptions) {
  let requestDTO;
  let quantity;
  const { brand, GiftMsg } = payload;
  let { catEntryId, hasGiftWrapping } = payload;
  if (catEntryId?.split('_')?.[0] === 'none') {
    hasGiftWrapping = false;
    // eslint-disable-next-line prefer-destructuring
    catEntryId = catEntryId.split('_')[1];
  }
  if (hasGiftWrapping && catEntryId) {
    quantity = 1;
  } else if (hasSetGiftOptions) {
    quantity = 0;
  }
  if (
    quantity >= 0 &&
    catEntryId !== 'standard' &&
    catEntryId !== GIFT_SERVICES_CONSTANTS.GIFT_SERVICES_NONE_VALUE
  ) {
    requestDTO = {
      c_giftMessage: GiftMsg || '',
      giftOption: {
        c_brand: brand,
        c_giftOption: true,
        productId: catEntryId,
        quantity,
      },
    };
  }

  return requestDTO;
}

export function createShippingAddressRequestDTO(payload) {
  let phone = '';
  const {
    addressId = '',
    addressLine1: address1,
    addressLine2: address2 = '',
    validationCode: c_validationCode = '',
    city,
    country: countryCode,
    emailAddress,
    firstName,
    lastName,
    state: stateCode,
    zipCode: postalCode,
    smsInfo,
    isCommercialAddress,
    isLoginV2FlowEnabled,
    phoneCountryCode,
    isInternationalPhoneNumberEnabled,
  } = payload;
  if (isLoginV2FlowEnabled) {
    phone = payload?.phone;
  } else {
    phone = payload?.phoneNumber;
  }
  const shippingPayload = {
    c_vibesSmsPhoneNo: smsInfo?.wantsSmsOrderUpdates ? smsInfo?.smsUpdateNumber : '',
    c_deliveryIndicator: isCommercialAddress ? '2' : '1',
    shippingAddress: {
      address1,
      address2,
      c_addressId: addressId,
      c_addressType: 'ShippingAndBilling',
      c_emailAddress: emailAddress,
      c_validationCode,
      city,
      countryCode,
      firstName,
      lastName,
      phone,
      postalCode,
      stateCode,
    },
  };

  if (isInternationalPhoneNumberEnabled) {
    shippingPayload.shippingAddress.c_phoneCountryCode = phoneCountryCode || '';
  }

  return shippingPayload;
}

export function* addAndSetGiftWrappingOptions(payload, hasSetGiftOptions) {
  const errorMappings = yield select(BagPageSelectors.getErrorMapping);
  if (payload.hasGiftWrapping) {
    try {
      const res = yield call(addGiftWrappingOption, payload, errorMappings);
      if (res) {
        yield put(setGiftWrap(payload));
      }
    } catch (err) {
      // throw getSubmissionError(store, 'submitShippingSection', err);
    }
  } else if (hasSetGiftOptions) {
    try {
      const res = yield call(removeGiftWrappingOption, payload);
      if (res) {
        yield put(setGiftWrap(payload));
      }
    } catch (err) {
      // throw getSubmissionError(store, 'submitShippingSection', err);
    }
  }
}

export function* getVenmoClientTokenSaga(payload) {
  try {
    const response = yield call(getVenmoToken, payload.payload);
    yield put(getVenmoClientTokenSuccess(response));
  } catch (ex) {
    yield put(getVenmoClientTokenError({ error: 'Error' }));
  }
}

export function* getAppleClientTokenSaga(payload) {
  yield put(appleLoaderState(true));
  const response = yield call(getAppleToken, payload.payload);
  yield put(getAppleClientTokenSuccess(response));
  yield put(appleLoaderState(false));
}

export function* saveLocalSmsInfo(smsInfo = {}) {
  let returnVal;
  const { wantsSmsOrderUpdates, smsUpdateNumber } = smsInfo;
  if (smsUpdateNumber) {
    if (wantsSmsOrderUpdates) {
      returnVal = yield put(setSmsNumberForUpdates(smsUpdateNumber));
    } else {
      returnVal = yield put(setSmsNumberForUpdates(null));
    }
  }
  return returnVal;
}

export function* addOrEditGuestUserAddress({
  oldShippingDestination,
  address,
  phoneNumber,
  emailAddress,
  saveToAccount,
  setAsDefault,
}) {
  let addOrEditAddressRes;
  if (!oldShippingDestination.onFileAddressKey) {
    const payload = {
      ...address,
      address1: address.addressLine1,
      address2: address.addressLine2 ? address.addressLine2 : '',
      zip: address.zipCode,
      phoneNumber,
      emailAddress,
      primary: setAsDefault,
      phone1Publish: `${saveToAccount}`,
      fromPage: 'checkout',
    };
    const updatedPayload = { ...payload };
    yield call(addUpdateAddress, updatedPayload);
  } else {
    // guest user is editing a previously entered shipping address
    addOrEditAddressRes = yield call(
      updateAddressPut,
      {
        payload: {
          ...address,
          address1: address.addressLine1,
          address2: address.addressLine2 ? address.addressLine2 : '',
          zip: address.zipCode,
          phoneNumber,
          nickName: oldShippingDestination.onFileAddressKey,
          emailAddress,
        },
      },
      {}
    );
    addOrEditAddressRes = { payload: addOrEditAddressRes };
  }
  return addOrEditAddressRes;
}

export function* updateShipping(updateShippingRequestDto) {
  try {
    const errorMappings = yield select(BagPageSelectors.getErrorMapping);
    return yield call(
      updateShippingAddressMethodAndGiftOption,
      updateShippingRequestDto,
      errorMappings
    );
  } catch (err) {
    if (
      err?.errorCodes &&
      err?.errorCodes?.indexOf(constants.ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION) > -1
    ) {
      yield put(
        fetchDefaultShipmentMethods({
          pageEvent: constants.ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION,
        })
      );
    }
    throw err;
  } finally {
    yield put(isPlccIsShippingAddressModalOpen(false));
  }
}

export function* callPickupSubmitMethod(formData) {
  let emailAddress = '';
  let firstName = '';
  let lastName = '';
  if (formData.hasAlternatePickup && formData.pickUpAlternate) {
    ({ emailAddress, firstName, lastName } = formData.pickUpAlternate);
  }
  return yield call(addPickupPerson, {
    firstName: formData.pickUpContact.firstName,
    lastName: formData.pickUpContact.lastName,
    phoneNumber: formData.pickUpContact.phoneNumber,
    emailAddress:
      formData.pickUpContact.emailAddress ||
      (yield select(isGuest) ? yield select(getUserEmail) : ''),
    alternateEmail: emailAddress,
    alternateFirstName: firstName,
    alternateLastName: lastName,
  });
}

function* updateUserRTPSData(payload) {
  const {
    prescreen,
    isExpressCheckoutEnabled,
    address,
    businessPhoneNumber,
    emailAddress = '',
  } = payload;
  try {
    const addressIds = yield select(BagPageSelectors.getAddressIds);
    let isRtpsPrescreenValid = false;
    const isRtpsBrowsePrescreened = yield select(getIsPrescreenFromBrowse);

    const rtpsModalTimeStamp = getSessionStorage('rtpsModalTimeStamp') || '';
    const rtpsModalThreshold = yield select(getRtpsModalThreshold);
    isRtpsPrescreenValid = Date.now() - rtpsModalTimeStamp > rtpsModalThreshold;
    if (
      (!isRtpsBrowsePrescreened || isRtpsPrescreenValid) &&
      addressIds.previousId !== addressIds.currentId
    ) {
      yield put(
        BAG_PAGE_ACTIONS.updateAddressIds({
          previousId: addressIds.currentId,
          currentId: addressIds.currentId,
        })
      );
      const res = yield updateRTPSData(
        prescreen,
        isExpressCheckoutEnabled,
        address,
        businessPhoneNumber,
        emailAddress
      );
      yield ApplyCardDynamicStore();
      yield put(setPlccEligible(res.plccEligible));
      yield put(setPlccPrescreenCode(res.prescreenCode));
      if (res.plccEligible) {
        // offer not yet shown, show it
        yield put(CHECKOUT_ACTIONS.setIsRTPSFlow(true));
        setLocalStorage({ key: 'isApplyNowModalShown', value: JSON.stringify(true) });
        yield ApplyCardDynamicStore();
        yield put(toggleApplyNowModal({ isModalOpen: true }));
      }
    }
  } catch (e) {
    logger.error(e);
  }
}

export function* callUpdateRTPS(
  pageName,
  navigation,
  isPaypalPostBack,
  isVenmoInProgress,
  address,
  phoneNumber,
  emailAddress = ''
) {
  const { BILLING, REVIEW } = constants.CHECKOUT_STAGES;
  const showRTPSOnBilling = yield select(selectors.getShowRTPSOnBilling);
  const showRTPSOnReview = yield select(selectors.getshowRTPSOnReview);
  const isExpress = yield select(isExpressCheckout);
  // For Venmo, express checkout fromPage flag is returning plcc eligibility as false.
  // So, updating to process as normal fromPage for Venmo
  const isExpressCheckoutEnabled = isVenmoInProgress ? false : isExpress;
  const isApplyNowModalShown = getLocalStorage('isApplyNowModalShown');
  if (!isApplyNowModalShown) {
    if ((pageName === 'SPC' || pageName === BILLING) && showRTPSOnBilling) {
      yield call(updateUserRTPSData, {
        prescreen: true,
        isExpressCheckoutEnabled: false,
        navigation,
        address,
        businessPhoneNumber: phoneNumber,
        emailAddress,
      });
    } else if (
      showRTPSOnReview &&
      (isPaypalPostBack || isVenmoInProgress || isExpress) &&
      pageName === REVIEW
    ) {
      yield call(updateUserRTPSData, { prescreen: true, isExpressCheckoutEnabled, navigation });
    }
  }
}

export const makeUpdateRTPSCall = (
  pageName,
  isPaypalPostBack,
  isExpressCheckoutEnabled,
  isVenmoInProgress
) => {
  const { BILLING } = constants.CHECKOUT_STAGES;

  return (
    pageName === BILLING || (isPaypalPostBack && !isExpressCheckoutEnabled) || isVenmoInProgress
  );
};

export function* submitAcceptOrDeclinePlccData({ payload }) {
  const preScreenData = yield select(getRtpsPreScreenData);
  const { preScreenCode } = preScreenData;
  const contactData = yield select(getSavedContactDetails);
  const { emailAddress = '' } = contactData || {};
  const emailAddressLoggedInUser = yield select(getUserEmail);
  const email = emailAddress || emailAddressLoggedInUser;
  const { accepted, presentationInd } = payload;
  try {
    yield acceptOrDeclinePreScreenOffer(preScreenCode, accepted, presentationInd, email);
  } catch (e) {
    logger.error(e);
  }
}
export function* handleCheckoutInitRouting({ pageName, ...otherProps }, appRouting) {
  const checkoutRoutingDone = yield select(selectors.getIfCheckoutRoutingDone);
  if (!checkoutRoutingDone && !appRouting) {
    yield call(getRouteToCheckoutStage, { pageName, ...otherProps });
  }
  return pageName;
}

export function shouldInvokeReviewCartCall(
  isExpressCheckoutEnabled,
  { initialLoad, isPaypalPostBack, pageName, appRouting: isPageRefreshRouting }
) {
  const { REVIEW } = constants.CHECKOUT_STAGES;
  const isExpressCheckoutCase = isExpressCheckoutEnabled && !isPaypalPostBack;
  return pageName === REVIEW && !isPageRefreshRouting && (!isExpressCheckoutCase || !initialLoad);
}

export function* redirectFromExpress() {
  yield put(toggleCheckoutRouting(true));
  yield put(setIsExpressEligible(false));
  yield put(setIsRedirectFromExpress(true));
  const isOrderHasPickup = yield select(selectors.getIsOrderHasPickup);
  if (isOrderHasPickup) {
    return utility.routeToPage(CHECKOUT_ROUTES.pickupPage);
  }
  return utility.routeToPage(CHECKOUT_ROUTES.shippingPage);
}

export function getShippingEventType(
  loadPageEvent,
  isShipmentMethodCached,
  userAddresses,
  shippingAddress
) {
  const {
    LOAD_SHIPMMENT_METHODS,
    CHANGE_SHIPMMENT_METHODS,
    ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION,
  } = constants;

  if (loadPageEvent === ERR_STATE_DOES_NOT_MATCH_SHIPMENT_OPTION) {
    return LOAD_SHIPMMENT_METHODS;
  }

  if (
    !loadPageEvent ||
    (userAddresses && userAddresses.size > 0) ||
    (shippingAddress && shippingAddress.state)
  ) {
    return CHANGE_SHIPMMENT_METHODS;
  }
  return isShipmentMethodCached ? LOAD_SHIPMMENT_METHODS : CHANGE_SHIPMMENT_METHODS;
}
